/**
 * Method that allocates an Array.
 *
 * @param {number} n
 * @return {Array}
 */
const alloc = (n) => new Array(n);
export default alloc;
